import { ResponsiveSunburst } from '@nivo/sunburst';

const sunburstData = {
  name: 'Project Alpha',
  color: 'hsl(13, 70%, 50%)',
  children: [
    {
      name: 'Feature A',
      color: 'hsl(106, 70%, 50%)',
      children: [
        { name: 'Completed', value: 10 },
        { name: 'In Progress', value: 5 }
      ]
    },
    {
      name: 'Feature B',
      color: 'hsl(171, 70%, 50%)',
      children: [
        { name: 'Finished', value: 8 },
        { name: 'Active', value: 2 },
        { name: 'To Do', value: 4 }
      ]
    },
    {
      name: 'Bug Fixes',
      color: 'hsl(215, 70%, 50%)',
      children: [
        { name: 'Resolved', value: 15 },
        { name: 'Pending', value: 3 }
      ]
    }
  ]
};

export const TaskDistributionChart = () => (
  <div style={{ height: '400px' }}>
    <ResponsiveSunburst
      arcLabelsSkipAngle={10}
      arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 1.4]] }}
      borderColor="white"
      borderWidth={1}
      childColor={{ from: 'color', modifiers: [['brighter', 0.1]] }}
      colors={{ scheme: 'nivo' }}
      cornerRadius={2}
      data={sunburstData}
      enableArcLabels={true}
      id="name"
      margin={{ top: 10, right: 10, bottom: 10, left: 10 }}
      value="value"
    />
  </div>
);
